import React from "react";
import { FormattedMessage } from "react-intl.macro";

export const LoggedOut = (
  <FormattedMessage id="shared.LoggedOut" defaultMessage="Utente disconnesso" />
);
